<div class="table-search" style="margin:0 0 5px 0;">
  <input #gb
         (input)="dt.filterGlobal($event.target.value, 'contains')"
         placeholder="Search..."
         pInputText
         type="text">
  <p-button id="edit-filter-button"
            alt="Edit Filter"
            (onClick)="showFilterDialog()"
            title="Advanced Filter"
            pTooltip="Edit Filter"
            tooltipPosition="left"
            [text]="true">
      <i class="pi pi-filter"></i>
      <i *ngIf="hasCustomFilter" class="pi pi-check custom-filter"></i>
  </p-button>
  <p-button id="download-button"
            *ngIf="displayExportButton"
            alt="Export CSV"
            (onClick)="export()"
            icon=" pi pi-download"
            pTooltip="Export CSV"
            tooltipPosition="left"
            [text]="true">
  </p-button>
</div>
<div #container class="data-table">
  <p-table #dt (onFilter)="filteredCount = $event.filteredValue.length"
           [value]="filteredUsers"
           [loading]="loading"
           responsiveLayout="scroll"
           [scrollable]="true"
           scrollHeight="flex"
           selectionMode="multiple"
           [(selection)]="selectedUsers"
           [columns]="columns"
           [dataKey]="dataKey"
           (onRowUnselect)="onRowUnSelect()"
           (onRowSelect)="onRowSelect()">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th style="width: 50px">
          <input type="checkbox"
                 [disabled]="filteredUsers?.length === 0"
                 [checked]="selectAllState === 'all'"
                 (change)="toggleSelectAll($event)"
                 [indeterminate]="selectAllState === 'indeterminate'"
                 [ngClass]="{
                   'checkbox-selected': selectAllState === 'all',
                   'checkbox-indeterminate': selectAllState === 'indeterminate',
                   'checkbox-unselected': selectAllState === 'none'
                 }">
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-userProfile let-rowData let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns" class="ui-resizable-column">
          <ng-template #defaultFormat>{{formatValue(col, rowData)}}</ng-template>
          <ng-template #dateFormat>{{rowData[col.field] | date:'dd-MMM-yyyy'}}</ng-template>
          <div *ngIf="needDateFormat(col); then dateFormat else defaultFormat"></div>
        </td>
        <td style="width: 50px" class="table-selected-column">
          <input type="checkbox" [checked]="isRowSelected(rowData)" (change)="toggleRowSelection(rowData)"
                 [ngClass]="{
                   'checkbox-selected': isRowSelected(rowData),
                   'checkbox-unselected': !isRowSelected(rowData)
                 }">
        </td>
      </tr>
    </ng-template>
  </p-table>
  <mojo-table-paginator [table]="dt" [showPaginator]="false" [rowCountOverride]="filteredCount"></mojo-table-paginator>
</div>
<mojo-filter-editor-dialog
  (onSaveFilter)="filterEdited($event)"
  [queryConfig]="queryConfig">
</mojo-filter-editor-dialog>
